import { defineStore } from 'pinia'

export const useLoginStore = defineStore('login-store', {
  state: () => ({ services: [] }),
  getters: {
    all: state => state.ramos
  },
  actions: {
    async add(srv) {
      this.services.indexOf(srv) !== -1 || this.services.push(srv)
    },
    async get(url) {
      return this.services.filter(srv => url.startsWith(srv.baseUrl))
    }
  },
})
